import HttpCliente from "../HttpCliente";

// ── Estados de seguimiento (mantenedor por cliente) ──
export const getEstadosSeguimiento = (token, idCliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Seguimiento/EstadosPorCliente/${idCliente}`, {
      headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error al obtener estados:", e.response?.data || e); reject(e); });
  });
};

export const crearEstadoSeguimiento = (token, dto) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Seguimiento/CrearEstado", dto, {
      headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json", "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error al crear estado:", e.response?.data || e); reject(e); });
  });
};

export const deshabilitarEstadoSeguimiento = (token, idEstado) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/Seguimiento/DeshabilitarEstado/${idEstado}`, {
      headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" },
    }).then(r => resolve(r.data)).catch(e => reject(e));
  });
};

export const editarEstadoSeguimiento = (token, dto) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Seguimiento/EditarEstado", dto, {
      headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json", "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error al editar estado:", e.response?.data || e); reject(e); });
  });
};

// ── Seguimiento ──
export const getSeguimiento = (token, idUsuario, idNormativa, idCliente) => {
  return new Promise((resolve, reject) => {
    const qs = new URLSearchParams({ idUsuario, idNormativa, idCliente });
    HttpCliente.get(`/Seguimiento/Obtener?${qs}`, {
      headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error al obtener seguimiento:", e.response?.data || e); reject(e); });
  });
};

export const actualizarEstadoSeguimiento = (token, dto) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Seguimiento/ActualizarEstado", dto, {
      headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json", "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error al actualizar estado:", e.response?.data || e); reject(e); });
  });
};

export const agregarObservacion = (token, dto) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Seguimiento/AgregarObservacion", dto, {
      headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json", "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error al agregar observación:", e.response?.data || e); reject(e); });
  });
};

export const getEstadosSeguimientoUsuario = (token, idUsuario) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Seguimiento/EstadosPorUsuario/${idUsuario}`, {
      headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error al obtener estados del usuario:", e.response?.data || e); reject(e); });
  });
};